// Alternative for Object.values() that works better with type checks when a custom key type is used.
export const values = <T extends object>(obj: T): Array<T[keyof T]> => Object.values(obj)
